import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { ButtonGroup, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import CronTaskForm from '../CronTaskForm/CronTaskForm';
import PageTitle from '../../../components/PageTitle/PageTitle';

import { loadCronTask, updateCronTask } from '../../../redux/modules/cron_tasks';

const CronTaskEdit = ({ match }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();
    const { cron_task } = useSelector(state => state.cron_tasks, shallowEqual);

    useEffect(() => {
        const cron_taskId = match.params.cron_taskId;
        dispatch(loadCronTask(cron_taskId));
    }, [])

    const submit = (values) => {
        dispatch(updateCronTask(values));
    }

    let title = <span>{t('cron_tasks.cron_task', {count: 1})}</span>;
    if (cron_task)
        title = (
            <span>
                {t('cron_tasks.cron_task', {count: 1})}
                <small> |&nbsp;{ t('cron_tasks.update_cron_task', { name: cron_task.name })} </small>
            </span>
        );

    const actions =
    <div>
        {cron_task &&
        <ButtonGroup>
            <Button tag={Link} to="/cron_tasks" color="warning" size="sm">
                <i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}
            </Button>
        </ButtonGroup>
        }
    </div>

    return (
        <div className="CronTaskEdit">
            <PageTitle icon="tasks" title={ title } actions={ actions } />

            {cron_task &&
                <CronTaskForm cron_task={cron_task} onSubmit={ submit } />
            }
        </div>
    );
}

export default CronTaskEdit;
